import {appName} from "../config";

/**
 * Constants
 * */
export const moduleName = `navigation`;
const prefix = `${appName}/${moduleName}`;

export const NEXT = `${prefix}/NEXT`;
export const BACK = `${prefix}/BACK`;

/**
 * Reducer
 * */

export default function reducer(state = 0, action) {
  const {type} = action;

  switch (type) {
    case NEXT:
      return state + 1;

    case BACK:
      return state - 1;

    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const navigationSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */

export const next = () => ({
  type: NEXT
});

export const back = () => ({
  type: BACK
});
